import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, pipe } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceUnavailableService {

  constructor(private http: HttpClient) { }

  public isAanvraagAvailable(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiBaseUri}/features/aanvraag`)
    .pipe(catchError(err => of(false)));
  }

  public isBetalingAvailable(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiBaseUri}/features/betaling`)
      .pipe(catchError(err => of(false)));
  }
  
  public getBannerTekst(language: string): Observable<string> {
     return this.http.get(`${environment.apiBaseUri}/banners/talen/${language}`, {responseType: 'text'})
     .pipe(catchError(() => of(null)));
  }
}
